import { Inject, Injectable, Injector } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthModel } from 'src/app/modules/auth/_models/auth.model';

@Injectable()
/**
 * MC GPO-91 Interceptor para inyectar access token
 */
export class HeaderInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes('login')) {
      return next.handle(request);
    }

    const accessToken = this.getAuthFromLocalStorage()?.access_token;
    const reqClone = request.clone({ 
      setHeaders: {
         Authorization: `Bearer ${accessToken}`
      }
     });
    
    return next.handle(reqClone);
  }

  private getAuthFromLocalStorage(): AuthModel {
    try {
      const authData = JSON.parse(
        localStorage.getItem(`${environment.appVersion}-${environment.USERDATA_KEY}`)
      );
      return authData;
    } catch (error) {
      return undefined;
    }
  }
}
